<template>

<div class="videoExternal" @click="externalVideo" :name="vidName">
  <a :href="vidUrl" target="_blank"><span class="external-link"><slot></slot></span></a>
</div>

</template>

<script>

export default {
  name: 'VideoExternal',
    props: {
      button: '',
      vidUrl: '',
      vidName: ''
  },
  data: function () {
    return {
      showModal: false
  }
},
methods: {
  externalVideo() {
      this.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Clicked an External Video Link',
        eventLabel: this.vidName,
        eventValue: '1'
      })
    },
}

}

</script>

<style>

.videoExternal a {
    display: inline;
    cursor:pointer;
    color:black;
    text-decoration:none;
    line-height: 31px;
}

.videoExternal a > span {
    border-bottom: 3px solid #D3BC8D;
    transition-duration: .25s;
}
.videoExternal a > span:hover {
    background: #D3BC8D;
    transition-duration: .25s;
}





@media (max-width:1366px) {


}

@media (max-width:1024px) {



}

@media (max-width:1023px) {



}

@media (max-width:667px) {
.videoExternal a {
    line-height: 27px;
}


}


@media (max-width:420px) {



}


</style>


// WEBPACK FOOTER //
// src/components/VideoExternal.vue